const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "red",
  "orange",
  "amber",
  "yellow",
  "green",
  "emerald",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle"
] as const

export default {
  "slots": {
    "root": "relative overflow-hidden w-full rounded-lg p-4 flex gap-2.5",
    "wrapper": "min-w-0 flex-1 flex flex-col",
    "title": "text-sm font-medium",
    "description": "text-sm opacity-90",
    "icon": "shrink-0 size-5",
    "avatar": "shrink-0",
    "avatarSize": "2xl",
    "actions": "flex flex-wrap gap-1.5 shrink-0",
    "close": "p-0"
  },
  "variants": {
    "color": {
      "primary": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "red": "",
      "orange": "",
      "amber": "",
      "yellow": "",
      "green": "",
      "emerald": "",
      "teal": "",
      "cyan": "",
      "blue": "",
      "indigo": "",
      "purple": "",
      "pink": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": ""
    },
    "orientation": {
      "horizontal": {
        "root": "items-center",
        "actions": "items-center"
      },
      "vertical": {
        "root": "items-start",
        "actions": "items-start mt-2.5"
      }
    },
    "title": {
      "true": {
        "description": "mt-1"
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-primary text-inverted"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-secondary text-inverted"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-success text-inverted"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-info text-inverted"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-warning text-inverted"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-error text-inverted"
      }
    },
    {
      "color": "red" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-red text-inverted"
      }
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-orange text-inverted"
      }
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-amber text-inverted"
      }
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-yellow text-inverted"
      }
    },
    {
      "color": "green" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-green text-inverted"
      }
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-emerald text-inverted"
      }
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-teal text-inverted"
      }
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-cyan text-inverted"
      }
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-blue text-inverted"
      }
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-indigo text-inverted"
      }
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-purple text-inverted"
      }
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-pink text-inverted"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-primary ring ring-inset ring-primary/25"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-secondary ring ring-inset ring-secondary/25"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-success ring ring-inset ring-success/25"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-info ring ring-inset ring-info/25"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-warning ring ring-inset ring-warning/25"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-error ring ring-inset ring-error/25"
      }
    },
    {
      "color": "red" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-red ring ring-inset ring-red/25"
      }
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-orange ring ring-inset ring-orange/25"
      }
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-amber ring ring-inset ring-amber/25"
      }
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-yellow ring ring-inset ring-yellow/25"
      }
    },
    {
      "color": "green" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-green ring ring-inset ring-green/25"
      }
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-emerald ring ring-inset ring-emerald/25"
      }
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-teal ring ring-inset ring-teal/25"
      }
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-cyan ring ring-inset ring-cyan/25"
      }
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-blue ring ring-inset ring-blue/25"
      }
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-indigo ring ring-inset ring-indigo/25"
      }
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-purple ring ring-inset ring-purple/25"
      }
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-pink ring ring-inset ring-pink/25"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-primary/10 text-primary"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-secondary/10 text-secondary"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-success/10 text-success"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-info/10 text-info"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-warning/10 text-warning"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-error/10 text-error"
      }
    },
    {
      "color": "red" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-red/10 text-red"
      }
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-orange/10 text-orange"
      }
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-amber/10 text-amber"
      }
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-yellow/10 text-yellow"
      }
    },
    {
      "color": "green" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-green/10 text-green"
      }
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-emerald/10 text-emerald"
      }
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-teal/10 text-teal"
      }
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-cyan/10 text-cyan"
      }
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-blue/10 text-blue"
      }
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-indigo/10 text-indigo"
      }
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-purple/10 text-purple"
      }
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-pink/10 text-pink"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-primary/10 text-primary ring ring-inset ring-primary/25"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-secondary/10 text-secondary ring ring-inset ring-secondary/25"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-success/10 text-success ring ring-inset ring-success/25"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-info/10 text-info ring ring-inset ring-info/25"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-warning/10 text-warning ring ring-inset ring-warning/25"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-error/10 text-error ring ring-inset ring-error/25"
      }
    },
    {
      "color": "red" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-red/10 text-red ring ring-inset ring-red/25"
      }
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-orange/10 text-orange ring ring-inset ring-orange/25"
      }
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-amber/10 text-amber ring ring-inset ring-amber/25"
      }
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-yellow/10 text-yellow ring ring-inset ring-yellow/25"
      }
    },
    {
      "color": "green" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-green/10 text-green ring ring-inset ring-green/25"
      }
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-emerald/10 text-emerald ring ring-inset ring-emerald/25"
      }
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-teal/10 text-teal ring ring-inset ring-teal/25"
      }
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-cyan/10 text-cyan ring ring-inset ring-cyan/25"
      }
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-blue/10 text-blue ring ring-inset ring-blue/25"
      }
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-indigo/10 text-indigo ring ring-inset ring-indigo/25"
      }
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-purple/10 text-purple ring ring-inset ring-purple/25"
      }
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-pink/10 text-pink ring ring-inset ring-pink/25"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "text-inverted bg-inverted"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-highlighted bg-default ring ring-inset ring-default"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "text-highlighted bg-elevated/50"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "text-highlighted bg-elevated/50 ring ring-inset ring-accented"
      }
    }
  ],
  "defaultVariants": {
    "color": "primary" as typeof color[number],
    "variant": "solid" as typeof variant[number]
  }
}